import ListBox from './ListBox';
import Collection from 'Support/Collection';
import RolesForm from './Forms/RolesForm';

export default class Roles extends ListBox {
    data() {
        return '/dashboard/profile/ajax/getRoles';
    }

    form() {
        return new RolesForm(this.loader);
    }

    process() {
        return function (data) {
            var displayNames = Collection.collect(data['roles']).pluck('displayName');
            return {
                title: 'Roles',
                items: Collection.collect(displayNames).itemsOrNone(),
                hideEdit: !data['canEditRoles']
            };
        };
    }

    load(containerId) {
        var container = $(containerId);
        container.expandable('div.card');
        container.on('expandable.showAll.clicked', function () {
            var accessList = container.find('.accessList');
            var expandLink = $(this).find('a.expand');

            if (accessList.hasClass('expanded')) {
                accessList.removeClass('expanded');
                expandLink.html(expandLink.data('text'));
            } else {
                accessList.addClass('expanded');
                expandLink.data('text', expandLink.html());
                expandLink.html('Collapse');
            }
            return false;
        });

        return super.load(containerId);
    }
}
